import { POLICY_MODULE, LAWS_REGULATIONS_MODULE } from "../../constants/modules";

export type PoliciesVariant = "standard" | "certificate";

export interface PoliciesModuleConfig {
  policyType: "fire_safety" | "hazardous_materials" | "laws_and_regulations";
  permissionModule: string;
  variant: PoliciesVariant;
  /** List screen route, e.g. "/policies-manuals" */
  listPath: string;
  /** Folder detail route prefix; detail URL is `${folderPath}/${id}` */
  folderPath: string;
  /** When true, the list shows folders from every module (not just policyType), badge-tagged by their real type */
  showAllTypes?: boolean;
  labels: {
    pageTitle: string;
    entitySingular: string;
    entityPlural: string;
    createButtonLabel: string;
    /** e.g. "Create Folder" | "Add New Law/Act/Regulation" (irregular, not derivable from entitySingular) */
    createModalTitle: string;
    /** Preserves each location's exact current wording, including quirks like surrounding quotes/casing */
    duplicateNameMessage: string;
    addFileButtonLabel: string;
  };
}

export const fireSafetyConfig: PoliciesModuleConfig = {
  policyType: "fire_safety",
  permissionModule: POLICY_MODULE,
  variant: "standard",
  listPath: "/policies-manuals",
  folderPath: "/folder",
  labels: {
    pageTitle: "Policies & Manuals",
    entitySingular: "Folder",
    entityPlural: "folders",
    createButtonLabel: "CREATE FOLDER",
    createModalTitle: "Create Folder",
    duplicateNameMessage: `" folder name already exists "`,
    addFileButtonLabel: "ADD FILES",
  },
};

export const hazardousMaterialsConfig: PoliciesModuleConfig = {
  policyType: "hazardous_materials",
  permissionModule: POLICY_MODULE,
  variant: "standard",
  listPath: "/hazardous-materials/policies-manuals",
  folderPath: "/hazardous-materials/policies-manuals/folder",
  labels: {
    pageTitle: "Policies & Manuals",
    entitySingular: "Folder",
    entityPlural: "folders",
    createButtonLabel: "CREATE FOLDER",
    createModalTitle: "Create Folder",
    duplicateNameMessage: `" folder name already exists "`,
    addFileButtonLabel: "ADD FILES",
  },
};

export const lawsAndRegulationsConfig: PoliciesModuleConfig = {
  policyType: "laws_and_regulations",
  permissionModule: LAWS_REGULATIONS_MODULE,
  variant: "certificate",
  listPath: "/laws-regulations-policies",
  folderPath: "/law-folder",
  showAllTypes: true,
  labels: {
    pageTitle: "Laws & Regulations",
    entitySingular: "Law/Act/Regulation",
    entityPlural: "laws/acts/regulations",
    createButtonLabel: "ADD NEW LAW",
    createModalTitle: "Add New Law/Act/Regulation",
    duplicateNameMessage: "Law/Act/Regulation name already exists",
    addFileButtonLabel: "ADD CERTIFICATE/REFERENCE",
  },
};

/** Each type's real folder-detail route prefix, used when a "showAllTypes" list navigates into a foreign-type folder */
export const folderPathByPolicyType: Record<PoliciesModuleConfig["policyType"], string> = {
  fire_safety: fireSafetyConfig.folderPath,
  hazardous_materials: hazardousMaterialsConfig.folderPath,
  laws_and_regulations: lawsAndRegulationsConfig.folderPath,
};
